/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Colleagues_TitleInputs */



/**
* | output |
* | --- |
* | "Colleagues Wundo follows" |
*
* @param {Meetings_Colleagues_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_colleagues_title = /** @type {((inputs?: Meetings_Colleagues_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Colleagues_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Collega's die Wundo volgt")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Collègues que Wundo suit")
	return /** @type {LocalizedString} */ ("Colleagues Wundo follows")
});